module.exports = __webpack_public_path__ + "img/Logo.5fe794ef.svg";